import styled from "styled-components";

export const StyledMoreActionsDropdown = styled.ul`
	padding: 1.3rem 1.5rem 1.3rem 1.1rem;

	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 3;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;

	border-radius: 0.4rem;
	background-color: white;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
	list-style: none;
	cursor: initial;

	transform: ${(props) => (props.direction === "right" ? "translateY(calc(100% + 1rem)" : "translate(-110%, calc(25% + 1rem)")});

	&.hidden {
		display: none;
	}

	&.done li {
		color: grey;
	}

	& li:not(:first-child) {
		margin-top: 1.5rem;
	}

	& li {
		white-space: nowrap;
		font-weight: 500;
		cursor: pointer;
		text-transform: capitalize;

		&::selection {
			background-color: transparent;
		}
	}
`;
